import { AssignableRecipient, User, UserMin } from '@apiContract';

import { isAssignableRecipient } from '@utils/recipient';

export const getRecipientId = (recipient?: AssignableRecipient | User | UserMin | null) => {
  if (!recipient) return null;
  if (isAssignableRecipient(recipient)) {
    if (recipient.groupId) return String(recipient.groupId);
    if (recipient.userId) return recipient.userId;
    return null;
  }
  return recipient.id;
};
